import React from "react";
import { Flex, Text, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ChartImage } from "@root/assets/icons/chart";

const IncidentsCard: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <Flex
      minW="600px"
      border="1px solid #E0E0E0"
      borderRadius="16px"
      padding="24px"
      gap="16px"
      flexDirection="column"
    >
      {/* Title */}
      <Text fontSize="24px" fontWeight="bold" color="black">
        {t("incidentsCard.title")}
      </Text>

      {/* Description */}
      <Text fontSize="18px" fontWeight="500" color="#5C6670" mb="16px">
        {t("incidentsCard.description")}
      </Text>

      {/* Chart */}
      <ChartImage />

      {/* Labels Row */}
      <Flex justifyContent="center" alignItems="center" gap={4} mt={4}>
        <Flex alignItems="center" gap={2}>
          <Box
            w="3"
            h="3"
            borderRadius="full"
            bg="blue.500"
            display="inline-block"
          />
          <Text fontSize="14px" color="gray.700" lineHeight="short">
            {t("incidentsCard.label2")}
          </Text>
        </Flex>

        <Flex alignItems="center" gap={2}>
          <Box
            w="3"
            h="3"
            borderRadius="full"
            bg="red.500"
            display="inline-block"
          />
          <Text fontSize="14px" color="gray.700" lineHeight="short">
            {t("incidentsCard.label1")}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default IncidentsCard;
